import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23da783a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scope-load-progress" }
const _hoisted_2 = { class: "scope-load-progress-value" }
const _hoisted_3 = { key: 0 }

import { computed } from 'vue'
import { useTransition, TransitionPresets } from '@vueuse/core'
import { useExploreStore } from '@/explore/ExploreStore'
import { useViewScopeStore } from '@/explore/ViewScopeStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'ScopeLoadProgress',
  setup(__props) {

const exploreStore = useExploreStore()
const viewScopeStore = useViewScopeStore()

const progressRef = computed(() => viewScopeStore.loadProgress.get(exploreStore.startPersonId ?? ''))
const personCount = computed(() => progressRef.value?.totalPersons ?? 0)
const personCountDisplay = useTransition(personCount, { duration: 500, transition: TransitionPresets.easeOutCubic })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(" Loading your family..."),
      (personCount.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(Math.round(_unref(personCountDisplay))), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})